export const inputType = {type: 'audio-file' as const};
